import styled from 'styled-components';

export const ModalWrapper = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;

  opacity: ${({ visible }) => (visible ? '1' : '0')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: all 0.15s;

  & > div {
    opacity: ${({ visible }) => (visible ? '1' : '0')};
    visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  }
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  position: fixed;
  padding: 10px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    max-width: 900px;
    max-height: 537px;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
    transition: all 0.3s;
    z-index: 15;
    padding: 20px;
    border-radius: 2px;

    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 250px;
  top: 40%;
  transform: translateY(-50%);

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 860px;
    height: 453px;
    max-height: 453px;
    top: unset;
    transform: unset;
    box-sizing: border-box;
    display: inline-flex;
  }

  & video {
    object-fit: fill;
  }
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;
